const enLocale = {
	browserNotSupported: 'Looks like your browser is not supported.',
	installOtherBrowser: 'Please upgrade to any of these options:',
	installNow: 'Install now',
};

export default enLocale;
